import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import counter from './counter'
import music from './music'
import photos from './photos'
import settings from './settings'
import auth from './auth'

export default combineReducers({
  router: routerReducer,
  counter,
  music,
  photos,
  settings,
  auth
})



// WEBPACK FOOTER //
// ./src/modules/index.js